import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";
import {AgentModel} from "../../../../agents/angular/models/agent.model";

@Component({
  standalone: false,
  selector: 'app-agent-link',
  templateUrl: './agent-link.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgentLinkComponent {

  @Input() agent: AgentModel;
  @Input() agentReference: any;
  @Input() agentId: string;
  @Input() agentName: string;

  @Output() linkClick = new EventEmitter<void>();

  public hasAgentGetPermission: boolean;

  constructor() {
  }

}
